document.addEventListener('DOMContentLoaded', () => {
  const galleries = document.querySelectorAll('.gfz-gallery');

  galleries.forEach((gallery) => {
    const slides = gallery.querySelectorAll('.gfz-slide');
    const thumbs = gallery.querySelectorAll('.gfz-thumb');

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const target = thumb.dataset.thumb;

        slides.forEach((slide) => {
          slide.classList.toggle('active', slide.dataset.media === target);
        });

        thumbs.forEach((item) => {
          item.classList.toggle('active', item === thumb);
        });
      });
    });
  });
});